'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { cn } from '@workspace/ui/lib';
import { useCallback, useEffect, useRef, useState } from 'react';

interface GradientProps {
  children: React.ReactNode;
  size?: string;
  type: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
  containerClassName?: string;
}

export function Gradient({
  children,
  size = '30%',
  type,
  className,
  containerClassName,
}: GradientProps) {
  const [showGradient, setShowGradient] = useState(true);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    if (!scrollContainerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight, scrollLeft, scrollWidth, clientWidth } =
      scrollContainerRef.current;

    let isAtEnd = false;
    if (type === 'top') {
      isAtEnd = scrollTop <= 1; // At top
    } else if (type === 'bottom') {
      isAtEnd = scrollTop + clientHeight >= scrollHeight - 1; // At bottom
    } else if (type === 'left') {
      isAtEnd = scrollLeft <= 1; // At left
    } else if (type === 'right') {
      isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1; // At right
    }

    setShowGradient(!isAtEnd);
  }, [type]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll);
      // Check initial state
      handleScroll();

      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll);
      };
    }
  }, [handleScroll]);

  const getGradientClasses = () => {
    switch (type) {
      case 'top':
        return 'absolute top-0 left-0 right-0 pointer-events-none bg-gradient-to-b from-grey-25 dark:from-grey-1000 to-transparent';
      case 'bottom':
        return 'absolute bottom-0 left-0 right-0 pointer-events-none bg-gradient-to-t from-grey-25 dark:from-grey-1000 to-transparent';
      case 'left':
        return 'absolute left-0 top-0 bottom-0 pointer-events-none bg-gradient-to-r from-grey-25 dark:from-grey-1000 to-transparent';
      case 'right':
        return 'absolute right-0 top-0 bottom-0 pointer-events-none bg-gradient-to-l from-grey-25 dark:from-grey-1000 to-transparent';
      default:
        return 'absolute bottom-0 left-0 right-0 pointer-events-none bg-gradient-to-t from-grey-25 dark:from-grey-1000 to-transparent';
    }
  };

  const getGradientStyle = () => {
    switch (type) {
      case 'top':
      case 'bottom':
        return { height: size };
      case 'left':
      case 'right':
        return { width: size };
      default:
        return { height: size };
    }
  };

  return (
    <div className={cn('relative flex-1 overflow-hidden', containerClassName)}>
      <div
        className={cn(
          'h-full',
          type === 'left' || type === 'right' ? 'overflow-x-scroll pb-2' : 'overflow-y-scroll pr-2',
          className
        )}
        ref={scrollContainerRef}
      >
        {children}
      </div>
      {showGradient && <div className={getGradientClasses()} style={getGradientStyle()} />}
    </div>
  );
}
